/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ per: NonNullable<unknown> }} Measure_Explainer_TitleInputs */

const en_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metered ${i?.per}`)
};

const zh_hans1_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`计量方式：${i?.per}`)
};

const pt_br2_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cobrado ${i?.per}`)
};

const es_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cobro ${i?.per}`)
};

const fr_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Facturé ${i?.per}`)
};

const de_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abgerechnet ${i?.per}`)
};

const ru_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тарификация ${i?.per}`)
};

const it_measure_explainer_title = /** @type {(inputs: Measure_Explainer_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Calcolato ${i?.per}`)
};

/**
* | output |
* | --- |
* | "Metered {per}" |
*
* @param {Measure_Explainer_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_title = /** @type {((inputs: Measure_Explainer_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Explainer_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_explainer_title(inputs)
	if (locale === "pt-BR") return pt_br2_measure_explainer_title(inputs)
	if (locale === "es") return es_measure_explainer_title(inputs)
	if (locale === "fr") return fr_measure_explainer_title(inputs)
	if (locale === "de") return de_measure_explainer_title(inputs)
	if (locale === "ru") return ru_measure_explainer_title(inputs)
	if (locale === "it") return it_measure_explainer_title(inputs)
	return en_measure_explainer_title(inputs)
});